import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AboutTeamCard from "./AboutTeamCard";
import pic1 from "../images/pic1.png";
import pic2 from "../images/pic2.png";
import pic3 from "../images/pic3.png";
import pic4 from "../images/pic4.png";
import pic5 from "../images/pic5.png";
const AboutTeam = () => {
  const data = [
    {
      name: "Arman Malik",
      img: pic1,
    },
    {
      name: "Shaily",
      img: pic2,
    },
    {
      name: "John Doe",
      img: pic3,
    },
    {
      name: "Annie",
      img: pic4,
    },
    {
      name: "Taylor",
      img: pic5,
    },
  ];
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <div className="mt-4 bg-gradient-to-tl from-slate-300 to-slate-100 pt-4 pb-8">
        <h2 className="font-bold w-full text-center text-4xl">MEET THE SQUAD</h2>
        <p className="w-full text-center text-xl text-gray-600 mt-2 mb-4">Our Team Members</p>
        <Slider {...settings}>
          {
            data.map((data)=>{
              return(
                <AboutTeamCard name={data.name} img={data.img}/>
              )
            })
          }
        </Slider>
      </div>
  )
}
export default AboutTeam